import { config } from './shared/config/env';
import { handleMfaRefusal } from '@/features/Auth/mfaReturn';
import { accessHeaders, isPortalHost } from '@/features/Auth/accessState';

/**
 * `fetch` for the BIASafe API: same cookie session, same refusal handling.
 *
 * Streaming and file-upload callers cannot use the axios client, but they must
 * not bypass what it does. This wrapper adds `credentials: 'include'` and
 * routes a 403 AU403MFAA (an account without a second factor attempting a
 * regulated action) to /security-setup via the same helper the axios
 * interceptor uses. The response is returned untouched, so existing error
 * handling keeps working.
 *
 * The only sanctioned way to call the API with `fetch`. A test fails if a new
 * raw `fetch(` appears elsewhere (see apiFetchUsage.test.ts).
 */
export const API_BASE = (
  isPortalHost() ? '/v1' : (config.api.baseUrl ?? '/v1')
).replace(/\/$/, '');

export async function apiFetch(
  path: string,
  init?: RequestInit,
): Promise<Response> {
  const headers = new Headers(init?.headers);
  Object.entries(accessHeaders()).forEach(([name, value]) =>
    headers.set(name, value),
  );
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...init,
    headers,
  });
  if (res.status === 403) {
    await handleMfaRefusal(res, { method: init?.method, url: path });
  }
  return res;
}
